
import { defineComponent, PropType } from 'vue'
import { BillingInfo } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'

export default defineComponent({
  name: 'StripeScaPendingAlert',
  props: {
    currentPlanName: {
      type: String,
      required: true
    },
    isBillingScaPending: {
      type: Boolean,
      required: true
    },
    ownerBillingInfo: {
      type: Object as PropType<BillingInfo>,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      lastPaymentAttemptDate: -1
    }
  },
  computed: {
    failedPaymentDate(): string | undefined {
      if (this.lastPaymentAttemptDate >= 0)
        return formatDate(parseISODate(this.lastPaymentAttemptDate), 'lll')
      return undefined
    }
  },
  created() {
    if (this.isBillingScaPending) this.getLastPaymentAttemptDate()
  },
  methods: {
    async getLastPaymentAttemptDate(): Promise<void> {
      if (this.ownerBillingInfo.clientSecret) {
        const stripePaymentIntent = await this.$stripe?.retrievePaymentIntent(
          this.ownerBillingInfo.clientSecret
        )
        if (stripePaymentIntent?.paymentIntent?.created) {
          this.lastPaymentAttemptDate = stripePaymentIntent.paymentIntent.created * 1000
          return
        }
      }
      this.lastPaymentAttemptDate = -1
    }
  }
})
